/*
 * Filename: component-tabs.container.tsx
 * Description: component for config tabs.
 */

import React, { Component } from 'react';
import { GridConfigHeaderTabs } from './grid-config-tab-header.component';
import { observer } from 'mobx-react';
import GridComponentConfigRootContainer from './component-config-grid/grid-component-config-root-component';
import { GridConfigRootComponent } from './grid-config-tab/grid-config-root.component';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';

interface IConfigTabsContainerProps {
    isLayoutApplicable: boolean;
    templateName: string;
    handleChange: Function;
    componentFields: any[],
    selectedTemplateName: string;
    errors: any,
    setCustomComponent: Function
}

class GridConfigTabsContainer extends Component<IConfigTabsContainerProps, { componentTabState: boolean }>{

    componentDidMount(){
        CQMasterDataStore.UtilityObject.setcomponentTabState();
    }

    render() {
        return (
            <div className="slds-col full-height full-width slds-scrollable_x">
                <div className="slds-grid slds-grid_vertical slds-tabs_default bg-white full-height">
                    <GridConfigHeaderTabs
                        selectedTemplateName={this.props.selectedTemplateName}
                        componentTabState={CQMasterDataStore.UtilityObject.componentTabState}
                        togglecomponentTabState={this.togglecomponentTabState} />
                    {
                        CQMasterDataStore.UtilityObject.componentTabState &&
                        <GridComponentConfigRootContainer errors={this.props.errors}
                            handleChange={this.props.handleChange}
                            componentFields={this.props.componentFields} selectedTemplateName={this.props.selectedTemplateName} setCustomComponent={this.props.setCustomComponent}/>
                    }
                    {
                        !CQMasterDataStore.UtilityObject.componentTabState &&
                        <GridConfigRootComponent templateName={this.props.templateName} setCustomComponent={this.props.setCustomComponent}/>
                    }
                </div>
            </div>
        );
    }


    /**
     * @private
     * @memberof GridConfigTabsContainer
     */
    private togglecomponentTabState = () => {
        CQMasterDataStore.UtilityObject.togglecomponentTabState();
    }
}

export default observer(GridConfigTabsContainer);
